export default __webpack_public_path__ + "static/TopHomegirard-3a1e059328b9009ec7208a55f5adeecb.jpg";